const MAX_RETRIES_LIFETIME = 40;
const MAX_RETRIES_PER_REQUEST = 3;

let lifetimeRetries = 0;

// The following can be used on the front-end example to simulate a token expiring:
// fetch(`https://sso-mod.dev1.mdgapp.net/as/revoke_token.oauth2`, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: `client_id=${window.FNC.CONSUMER_KEY}&token=${window.FNC.tokenService.currentTokens.main}` }).then(res => console.log(res))

export const expiredTokenInterceptor = (
  http,
  tokenProvider
) => async (error) => {
  // Check for supported errors and stop here if unsupported
  const isAuthError = error && error.response && error.response.status === 401;
  // CORS errors due to invalid tokens fall here
  const isNetworkError = error && error.message && error.message.toLowerCase() === "network error";
  if (!isAuthError && !isNetworkError) {
    // Unsupported error for this interceptor
    throw error;
  }

  error.config.attempts = (error.config.attempts || 0) + 1;
  if (error.config.attempts > MAX_RETRIES_PER_REQUEST || ++lifetimeRetries > MAX_RETRIES_LIFETIME) {
    console.warn('[FNC Fetch] Number of API token refresh attempts exhausted');
    throw error;
  }

  const nextToken = await tokenProvider();

  // For the retry
  error.config.headers = error.config.headers || {};
  error.config.headers["Authorization"] = `Bearer ${nextToken}`;
  // In case there are any other requests made by this instance of `http` 
  // (they shouldn't get reused, but you never know)
  http.defaults.headers["Authorization"] = `Bearer ${nextToken}`;

  return http.request(error.config);
};